// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
/*#region Text*/
/*#endregion */
/*#region Elements*/
/**#region Event Container */
/*#endregion*/
/*#endregion */
/* #region Screen */
/* #endregion*/
.filter-container {
  position: absolute;
  right: 25px;
  z-index: 5;
  width: 900px;
}
@media (max-width: 1349px) {
  .filter-container {
    width: 720px;
  }
}
@media (max-width: 1079px) {
  .filter-container {
    width: 470px;
  }
}
@media (max-width: 859px) {
  .filter-container {
    left: 25px;
  }
}
@media (max-width: 599px) {
  .filter-container {
    left: 50%;
    transform: translateX(-50%);
    width: 250px;
  }
}

.filter-flex-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  width: 900px;
}
@media (max-width: 1349px) {
  .filter-flex-container {
    width: 720px;
    flex-flow: row wrap;
  }
}
@media (max-width: 1079px) {
  .filter-flex-container {
    width: 470px;
  }
}
@media (max-width: 859px) {
  .filter-flex-container {
    justify-content: flex-start;
  }
}
@media (max-width: 599px) {
  .filter-flex-container {
    width: 250px;
  }
}

.filter-placeholder {
  font-style: italic;
  color: #6e849f;
}

.filter-component-container {
  margin-right: 20px;
}

.filter-box {
  display: inline-block;
  position: relative;
  margin-bottom: 6px;
  vertical-align: top;
}

.filter-flex-pair {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  gap: 8px;
}

.reset-filter-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  margin: 0 0 6px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #3b5873;
  cursor: pointer;
  transition: background-color 120ms ease, border-color 120ms ease, opacity 120ms ease;
}
.reset-filter-btn img {
  width: 18px;
  height: 18px;
  pointer-events: none;
}
.reset-filter-btn:hover:not(:disabled) {
  background: rgb(25.8498985801%, 38.5557809331%, 50.3853955375%);
  border-color: rgba(157, 188, 218, 0.25);
}
.reset-filter-btn:focus-visible {
  outline: 2px solid #52aaff;
  outline-offset: 2px;
}
.reset-filter-btn.inactive, .reset-filter-btn:disabled {
  background: #3f5061;
  opacity: 0.55;
  cursor: not-allowed;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
